// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"f8af9e27862329835bf1","303":"89010fdb1a0b98060c7a","495":"442fb436742b2db34f31"}[chunkId] + ".js";
};